import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';

class UnderConstruction extends Component {
    render() {
        return (
            <div className="info-page">
                <Header  />
                <div style={{
                    minHeight: 'calc(100vh - 180px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '60px 20px',
                    color: '#ffffff',
                    backgroundColor: '#15171b',
                }}>
                    <span class="material-symbols-outlined" style={{ fontSize: '110px', fontWeight: '700', marginBottom: '10px' }}>build_circle</span>
                    <h1 style={{ fontSize: '36px', fontWeight: '700', marginBottom: '16px' }}>Page Under Construction</h1>
                    <p style={{ fontSize: '16px', color: '#aaaaaa', maxWidth: '480px', lineHeight: '1.6' }}>
                        We're working on this page. Check back soon!
                    </p>
                    <button
                        onClick={() => this.props.history.goBack()}
                        style={{
                            marginTop: '32px',
                            padding: '12px 28px',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            border: '1px solid rgba(255,255,255,0.3)',
                            borderRadius: '6px',
                            color: '#ffffff',
                            fontSize: '14px',
                            cursor: 'pointer',
                        }}
                    >
                        Go Back
                    </button>
                </div>
                <Footer />
            </div>
        );
    }
}

export default UnderConstruction;
